import React from "react";

export default function RefundPolicy() {
  return (
    <main>
      <div
        style={{
          maxWidth: "1240px",
          margin: "4rem auto",
          padding: "0 1rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <h5>Refund Policy</h5>
        <p>
          Currently, we do not have any refund policy. we will update here once
          we start.
          {/* At BajajCapital, we are committed to providing exceptional products
          and services. While we strive for customer satisfaction, we do not
          currently offer refunds for any purchases made through our platform. */}
          {/* We do not currently offer refunds for any purchases made through our
          platform.
          <br /> <br />
          Exceptional Circumstances
          <br /> <br />
          In the rare event of a product or service defect or error on our part,
          we will review the situation on a case-by-case basis and may offer an
          appropriate resolution.
          <br /> <br />
          Contact Us
          <br /> <br />
          If you have any questions or concerns about your purchase, please
          don’t hesitate to contact us at contactus@bajajcapital.com. We’re here
          to assist you in any way we can. */}
        </p>
      </div>
    </main>
  );
}
